<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-card-actions
        class="mt-0 px-2 py-0 white"
        style="position: fixed; inset: 0 0 auto 0; z-index: 1;"
      >
        <v-card-title class="red--text darken-4">
          {{ item == null ? "" : item.group + '/' + item.name }}
        </v-card-title>
        <v-spacer></v-spacer>
        <v-btn
          class="ma-2"
          text
          @click="onClose"
        >
          Cancel
        </v-btn>

        <v-btn
          class="ma-2 white--text"
          color="blue"
          :disabled="!canApply"
          @click="onPressApply"
        >
          Apply
        </v-btn>
      </v-card-actions>

      <v-card-actions class="pa-0 mt-16">
        <v-card elevation="0" width="100%">
          <v-card-actions class="py-0">
            <v-card width="50%" class="blue--text overline font-weight-black" elevation="0">
              <v-card-actions>
                <v-simple-checkbox
                  :ripple="false"
                  @click="onCheck('a')"
                  :value="resolved.a"
                  color="blue"
                />
                {{ configA == null ? "" : configA.group }}
              </v-card-actions>
            </v-card>
            <v-spacer></v-spacer>
            <v-card width="50%" class="orange--text overline font-weight-black" elevation="0">
              <v-card-actions class="py-0">
                <v-simple-checkbox
                  :ripple="false"
                  @click="onCheck('b')"
                  :value="resolved.b"
                  color="orange"
                />
                {{ configB == null ? "" : configB.group }}
              </v-card-actions>
            </v-card>
          </v-card-actions>

          <v-card-text class="py-0">
            <div class="diff2html-container d2h-dark" v-html="renderedDiff"></div>
          </v-card-text>

          <v-divider class="my-2"></v-divider>

          <v-card class="purple--text text--darken-1 mx-2 overline font-weight-black" elevation="0">
            <v-card-actions class="py-0">
              <v-simple-checkbox
                :ripple="false"
                :value="isCustomNow"
                color="blue"
                disabled
              />
              CUSTOM
            </v-card-actions>
          </v-card>

          <v-card-text class="pt-2">
            <codemirror
              v-model="stringC"
              :options="cmOpt"
              class="cm-editor"
            />
          </v-card-text>
        </v-card>
      </v-card-actions>

      <v-card-actions>
        <v-spacer></v-spacer>


        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CodeMirror from "codemirror";
import { createTwoFilesPatch } from "diff";
import { html } from "diff2html";
import jsonlint from "jsonlint-mod";
window.jsonlint = jsonlint;
import 'diff2html/bundles/css/diff2html.min.css';

import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/monokai.css";
import "codemirror/addon/edit/matchbrackets";

import "codemirror/addon/search/searchcursor";
import "codemirror/addon/search/match-highlighter";

import "codemirror/addon/lint/lint";
import "codemirror/addon/lint/lint.css";
import "codemirror/addon/lint/json-lint";

import "codemirror/mode/javascript/javascript.js";


export default {
  name: "c-diff-preview-popup",
  components: { codemirror },
  data: () => ({
    dialog: false,
    stringA: '',
    stringB: '',
    stringC: '',
    configA: null,
    configB: null,
    item: null,
    resolved: { a: false, b: false },
    initialResolved: { a: false, b: false, c: false },
    initialStringC: '',
    lastBase: null,
    updatingFromToggle: false,
    customCache: {},
    cmOpt: {
      mode: 'application/json',
      theme: 'monokai',
      tabSize: 4,
      lineNumbers: true,
      lineWrapping: true,
      viewportMargin: Infinity,
      matchBrackets: true,
      highlightSelectionMatches: { showToken: true },
      gutters: ["CodeMirror-lint-markers"],
      lint: {
        tooltips: true,
        delay: 200,
        getAnnotations: (text, options, cm) => {
          const s = (text || "").trim();
          if (!s) return [];
          return CodeMirror.lint.json(text, options, cm);
        }
      }
    }
  }),
  computed: {
    renderedDiff() {
      const a = this.stringA || '';
      const b = this.stringB || '';
      if (!a && !b) return '';

      const patch = createTwoFilesPatch(
        this.configA?.group || 'A',
        this.configB?.group || 'B',
        a,
        b
      );

      return html(patch, {
        drawFileList: false,
        matching: 'lines',
        outputFormat: 'side-by-side',
        colorScheme: 'dark',
      });
    },

    jsonValid() {
      const s = (this.stringC || '').trim();
      if (!s) return true;
      try {
        JSON.parse(s);
        return true;
      } catch (e) {
        return false;
      }
    },

    canApply() {
      if (!this.jsonValid) return false;
      return this.hasChanges;
    },

    hasChanges() {
      const norm = (s) => (s || '').trim();

      const curr = { a: !!this.resolved.a, b: !!this.resolved.b, c: this.isCustomNow };
      const init = {
        a: !!this.initialResolved.a,
        b: !!this.initialResolved.b,
        c: !!this.initialResolved.c
      };

      const resolvedChanged = (curr.a !== init.a) || (curr.b !== init.b) || (curr.c !== init.c);
      const cChanged = norm(this.stringC) !== norm(this.initialStringC);

      const nothingSelected = !this.resolved.a && !this.resolved.b && !norm(this.stringC);
      if (nothingSelected) return false;

      return resolvedChanged || cChanged;
    },

    isCustomNow() {
      const norm = (s) => (s || '').trim();
      const a = norm(this.stringA);
      const b = norm(this.stringB);
      const c = norm(this.stringC);
      if (!c) return false;
      return c !== a && c !== b;
    }
  },

  watch: {
    stringC(newVal) {
      if (!this.dialog) return;
      if (this.updatingFromToggle) return;

      const a = (this.stringA || '').trim();
      const b = (this.stringB || '').trim();
      const c = (newVal || '').trim();

      if (this.resolved.a && c !== a) {
        this.resolved.a = false;
      }
      if (this.resolved.b && c !== b) {
        this.resolved.b = false;
      }
    }
  },

  methods: {
    show(resolved, configA, configB, dataA, dataB, item) {
      this.dialog = true;
      this.item = item;
      this.resolved = { ...resolved };
      this.configA = configA;
      this.configB = configB;

      const childA = (dataA?.[item.group]?.[item.uid]) ?? {};
      const childB = (dataB?.[item.group]?.[item.uid]) ?? {};
      this.stringA = JSON.stringify(childA, null, 4);
      this.stringB = JSON.stringify(childB, null, 4);

      const key = `${item.group}/${item.uid}`;

      if (resolved.c && this.customCache[key]) {
        this.stringC = this.customCache[key];
      } else if (resolved.a) {
        this.stringC = this.stringA;
      } else if (resolved.b) {
        this.stringC = this.stringB;
      } else {
        this.stringC = '';
      }

      this.lastBase = resolved.a ? 'a' : (resolved.b ? 'b' : this.lastBase);

      this.initialResolved = { ...this.resolved, c: !!resolved.c };
      this.initialStringC = this.stringC;
    },

    onClose() {
      this.dialog = false;
    },

    onPressApply() {
      if (!this.canApply) return;

      const a = (this.stringA || '').trim();
      const b = (this.stringB || '').trim();
      const c = (this.stringC || '').trim();
      const isCustom = c !== a && c !== b;

      const base = this.resolved.a ? 'a' : (this.resolved.b ? 'b' : this.lastBase);

      const resolved = { ...this.resolved, c: isCustom };
      if (isCustom && base) resolved[base] = true;

      const key = `${this.item.group}/${this.item.uid}`;
      if (isCustom) {
        this.customCache[key] = this.stringC;
      } else {
        delete this.customCache[key];
      }

      this.dialog = false;
      this.$emit('resolve-conflict', resolved, this.item, this.stringC);
    },

    onCheck(tag) {
      if (tag === 'a') {
        const was = this.resolved.a;
        this.resolved.a = !was;
        this.resolved.b = false;
        this.lastBase = this.resolved.a ? 'a' : this.lastBase;
        this.updatingFromToggle = true;
        this.stringC = this.resolved.a ? this.stringA : '';
        this.$nextTick(() => (this.updatingFromToggle = false));
      } else {
        const was = this.resolved.b;
        this.resolved.b = !was;
        this.resolved.a = false;
        this.lastBase = this.resolved.b ? 'b' : this.lastBase;
        this.updatingFromToggle = true;
        this.stringC = this.resolved.b ? this.stringB : '';
        this.$nextTick(() => (this.updatingFromToggle = false));
      }
    },
  }
};
</script>

<style>
.diff2html-container {
  width: 100%;
  overflow-x: auto;
}

.CodeMirror {
  height: auto;
}

.cm-editor {
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
}

.CodeMirror-matchingbracket {
  background-color: rgba(0, 150, 255, 0.5);
  color: white;
}

.CodeMirror-nonmatchingbracket {
  background-color: rgba(255, 0, 0, 0.1);

}

.cm-matchhighlight {
  background: rgba(0, 150, 255, 0.2);
}

.CodeMirror-lint-tooltip {
  max-width: 520px;
  line-height: 1.3;
  white-space: pre-wrap;
  z-index: 99999;
}
</style>
